import { AdapterBase, RunResponseType } from "../../storyV2/adapter/AdapterBase";
import { AdapterResponseUtil } from "./AdapterResponseUtil";
import { FunctionName } from "../function/FunctionRegistry";
export class AddDataSourceAdapter extends AdapterBase {
    constructor() {
        super(...arguments);
        this.functionName = FunctionName.addDataSource;
    }
    dynamicRunResponseType() {
        if (this.lastFuncResType) {
            const resType = AdapterResponseUtil.responseTypeTransform(this.lastFuncResType);
            if (resType === RunResponseType.CUSTOM_API) {
                return RunResponseType.CUSTOM_API;
            }
        }
        return RunResponseType.TEXT;
    }
}
